import { type MaybeRefOrGetter, type Ref, toRef } from 'vue'

export default function useLoading(state: MaybeRefOrGetter<boolean> = false) {
  const loading: Ref<boolean> = toRef(state)

  function setLoading(state: boolean) {
    loading.value = state
  }

  return {
    loading,
    setLoading,
  }
}
